export class StaticConfig {
	static maxpageelement = 20;
	static mailmaxpageelement = 20;
	static id_categoria_contratto = 1;
	static fg_id_contratto_appalto = 0;
	static base_url_browser: string;
	static base_url: string;
	static portalUrl: string;
	static serviceUrl_Documentale: string;
	static companiesUrl: string;
	static wfUrl: string;
	static hrurl: string;
	static automezziUrl: string;
	static bookingUrl: string;
	static paymentUrl: string;
		static bakekaUrl: string;
	static onlineshopurl: string;
	static onlineshopUrl: string;
	static paypal_clientId: string;
	static nexi_script: string;
	static bizAppointmentsUrl: string;

	static drUrl: string;
	static serviceUrl_Login: string;
	static urlbaseLogin: string;
	static mailServiceUrl: string;
	static fattureConfigUrl: string;
	static urlRDBService: string;
	static urlRFIService: string;
	static urlRDBSqlServer: string;
	static urlStrike: string;
	static cnaUrl: string;
	static cestino: string;
	static inarrivo: string;
	static inviate: string;
	static bozze: string;
	static spam: string;
	static db_prefix: string;
	static apiGoogleMapsKey: string;
	static imageBaseURL: string;
	static onlineshopImageUrl: string;
	static bakekaImageUrl: string;
	static placesImageUrl: string;
	language = 'it';
	constructor() {}
}
